import React from 'react';
import { makeStyles } from '@material-ui/styles';
import { Schedule, CampaignTabBar } from './components';
import useCampaign from './useCampaign';

const useStyles = makeStyles(theme => ({
  root: {},
  content: {
    padding: theme.spacing(3)
  }
}));

const CampaignSchedule = props => {
  const campaign = useCampaign();
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <CampaignTabBar onTabChange={campaign.onTabChange} />
      <div className={classes.content}>
        <Schedule campaign={campaign} showNav={true} back="/campaigns/design" />
      </div>
    </div>
  );
};

export default CampaignSchedule;
